import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Blog.css";
import { FaEdit, FaTrash } from "react-icons/fa";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if the user is logged in as admin
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const user = token ? JSON.parse(token) : null;

    if (
      user &&
      user.username === "tushitasingh" &&
      user.password === "bdc12345"
    ) {
      setIsAdmin(true);
    }
  }, []);

  // Fetch blogs whenever the component is mounted or the route changes
  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        console.log("Fetching blogs...");

        const response = await fetch(
          "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/temp.php",
          {
            method: "GET",
            cache: "no-cache",
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("API Response:", data);

        if (data && data.data && Array.isArray(data.data)) {
          setBlogs(data.data);

        } else {
          console.error("Unexpected API response structure:", data);
          setBlogs([]);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [location]);

  // Handle blog deletion
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    try {
      const response = await fetch(
        "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/delete_blog.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        }
      );

      const result = await response.json();

      if (response.ok && result.status === "success") {
        alert("Blog deleted successfully!");
        setBlogs((prev) => prev.filter((blog) => blog.id !== id));
      } else {
        console.error("Failed to delete blog:", result);
        alert(result.message || "Failed to delete the blog. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting blog:", error);
      alert("An error occurred while deleting the blog.");
    }
  };

  // Navigate to the edit page
  const handleEdit = (blog) => {
    navigate("/admin/edit-blog", { state: { blog } });
  };





  return (
    <div className="blog">
      <div className="blog-sec1">
        <div className="content">
          <div className="text-section">
            <p className="trusted-text">
              <mark className="domark">ABOUT BOMBAY DENTAL CLINIC</mark>
            </p>
            <h1 className="exceptional">
              <mark className="expmrk">Learn about</mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">our blogs</mark>
            </h1>
            <a href="/booknow">
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
          </div>
        </div>
      </div>
      <div className="blog-section-container">
        <h1 className="blog-section-heading">Our Latest Blogs</h1>

        {loading ? (
          <p>Loading blogs...</p>
        ) : error ? (
          <p className="error-message">Failed to load blogs: {error.message}</p>
        ) : blogs.length > 0 ? (
          <div className="blog-cards-container">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-card" 
              style={{
                cursor: "pointer",
              }}
              onClick={() => navigate(`/blogs/${blog.id}`)}
              >
                <img
                  src={blog.image || "placeholder.jpg"}
                  alt={blog.title || "No Title"}
                  className="blog-image"
                />
                <div className="blog-details">
                  <h2 className="blog-title">{blog.title || "No Title"}</h2>
                  <p className="blog-meta">
                    {blog.date || "No Date"} |{" "}
                    {blog.category || "Uncategorized"}
                  </p>
                  <div className="blog-description">
                    {blog.description.slice(0, 200)+'...'}
                    
                  </div>
                
                  {isAdmin && (
                    <div className="admin-buttons">
                      <button
                        className="edit-button"
                        onClick={() => handleEdit(blog)}
                        disabled={deletingId === blog.id}
                      >
                        <FaEdit /> Edit
                      </button>
                      <button
                        className="delete-button"
                        onClick={() => {
                          setDeletingId(blog.id);
                          handleDelete(blog.id);
                        }}
                        disabled={deletingId === blog.id}
                      >
                        {deletingId === blog.id ? (
                          "Deleting..."
                        ) : (
                          <>
                            <FaTrash /> Delete
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No blogs available.</p>
        )}
      </div>
    </div>
  );
}

export default Blog;
